export default ({ color, typography, fontSize }) => ({
  apiTrafficChartContainer: {
    borderRadius: 5,
  },
  lineChartContainer: {
    width: '70%',
    borderRight: `1px solid ${color.borderColor}`,
    paddingLeft: 20,
    boxSizing: 'border-box',
    paddingBottom: 20,
    height: '26vw',
    '& svg': {
      overflow: 'visible',
      height: 'auto',
    },
    '& .VictoryContainer': {
      bottom: 22,
      display: 'flex',
      '& div:last-child': {
        height: '100%',
        display: 'flex',
      },
    },
    '@media print': {
      borderBottom: '1px solid #D8D8D8',
      borderLeft: '1px solid #D8D8D8',
      width: '100%',
      height: '40vw',
    },
  },
  labelForPrint: {
    display: 'none',
    marginTop: 40,
    '@media print': {
      display: 'block',
    },
  },
  trafficChartLabel: {
    fontSize: fontSize.xLarge,
    fontFamily: typography.siteTitle,
    padding: '22px 0 5px 16px',
    borderBottom: `1px solid ${color.borderColor}`,
  },
  chartTitle: {
    color: color.pageTitle,
    fontFamily: typography.pageTitle,
    fontSize: fontSize.sectionTitle,
    width: '70%',
    '@media print': {
      width: '100%',
    },
    boxSizing: 'border-box',
    display: 'inline-block',
  },
  chartContainer: {
    display: 'flex',
    maxHeight: '26vw',
    '@media print': {
      display: 'block',
      maxHeight: 'none',
    },
  },
  metricsLabel: {
    color: color.pageTitle,
    fontFamily: typography.pageTitle,
    fontSize: fontSize.title,
    width: '30%',
    display: 'inline-block',
    '@media print': {
      display: 'none',
    },
  },
  loader: {
    width: '100%',
    display: 'flex',
    height: 500,
    justifyContent: 'center',
    alignItems: 'center',
  },
  plcaeholderText: {
    paddingTop: '1%',
    color: color.bodyText,
    fontFamily: typography.bodyText,
    fontSize: fontSize.bodyText,
  },
  blockLegendItem: {
    display: 'inline-block',
    width: 25,
    height: 18,
    marginRight: 10,
    WebkitPrintColorAdjust: 'exact',
    colorAdjust: 'exact',
  },
  lineLegendItem: {
    display: 'inline-block',
    width: 30,
    height: 6,
    marginRight: 10,
    WebkitPrintColorAdjust: 'exact',
    colorAdjust: 'exact',
  },
  lineLegendItem__dashed: {
    height: 'auto',
    display: 'inline-block',
    width: 25,
    marginRight: 10,
    WebkitPrintColorAdjust: 'exact',
    colorAdjust: 'exact',
  },
});

